import * as types from "../actions/types";
import { motifs } from "../components/config/";

export default (state = motifs.QUADRILLAGE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SELECT_MOTIF:
      return payload;
    default:
      return state;
  }
};
